import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { Grid, Menu, MenuItem, Typography } from "@mui/material";
import { useState } from "react";
import useColors from "../../../api/hooks/useColors";
import LoadingIcon from "../../../components/LoadingIcon";
import { Toast } from "../../../components/Toast";

export default function FieldMenu({ value, valuesList, onClick }) {
  const [anchorEl, setAnchorEl] = useState();
  const open = Boolean(anchorEl);
  const colors = useColors();

  const [isLoading, setIsLoading] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = async (item) => {
    if (item === value) {
      setAnchorEl(null);
      return;
    }
    setIsLoading(true);
    setAnchorEl(null);
    try {
      await onClick(item);
    } catch (error) {
      Toast.error("An error occurred while trying to update the value");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Grid
        container
        onClick={handleClick}
        sx={{ cursor: "pointer" }}
        alignItems={"center"}
        justifyContent={isLoading ? "center" : "space-between"}
      >
        {isLoading ? (
          <LoadingIcon size={20} />
        ) : (
          <>
            <Typography variant="caption">{value}</Typography>
            <KeyboardArrowDownRoundedIcon
              sx={{ color: colors.grey_600, fontSize: "20px" }}
            />
          </>
        )}
      </Grid>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {valuesList.map((item) => (
          <MenuItem
            key={item}
            onClick={() => handleClose(item)}
            selected={item === value}
          >
            <Typography variant="caption">{item}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
